import React from 'react';
import { useTheme } from 'styled-components';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function SearchIcon() {
  const theme = useTheme();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_4897_12241)">
        <path
          d="M15.8523 15.1469L11.4307 10.725C12.4056 9.5875 12.9712 8.11563 12.9712 6.5C12.9712 2.90937 10.061 0 6.47155 0C2.88205 0 0 2.91031 0 6.5C0 10.0897 2.90986 13 6.47155 13C8.08646 13 9.56045 12.4075 10.6963 11.4328L15.118 15.8547C15.243 15.95 15.3711 16 15.4992 16C15.6273 16 15.7551 15.9512 15.8526 15.8535C16.0492 15.6594 16.0492 15.3406 15.8523 15.1469ZM6.49967 12C3.44045 12 0.999955 9.53125 0.999955 6.5C0.999955 3.46875 3.44045 1 6.49967 1C9.55889 1 11.9994 3.44062 11.9994 6.5C11.9994 9.55937 9.53076 12 6.49967 12Z"
          fill={theme.colors.iconIconSecondarySubtleGrey80}
        />
      </g>
      <defs>
        <clipPath id="clip0_4897_12241">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SearchIcon;
